/* eslint-disable no-param-reassign */
const getYPos = el => {
  let y = 0;
  while (el.offsetParent) {
    y += el.offsetTop;
    el = el.offsetParent;
  }
  return y;
};

const scroll = (hash, link) => {
  return () => {
    hash = hash.includes('#') ? hash.substring(1) : hash;
    const el = document.getElementById(hash);
    if (link) window.location.href = link;
    window.scrollTo(0, getYPos(el) - 90);
  };
};

export default scroll;
